
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as OwnerIconComponent } from "./owner-icon.svg";

export const OwnerIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <OwnerIconComponent {...props} />;
};
